export type ValidationRuleType = 'OnlyRequired' | 'Pattern' | 'Function' | 'Files' | 'PhoneNumber' | 'Email';
export const ValidationRuleType = {
  OnlyRequired: 'OnlyRequired' as ValidationRuleType,
  Pattern: 'Pattern' as ValidationRuleType,
  Function: 'Function' as ValidationRuleType,
  Files: 'Files' as ValidationRuleType,
  PhoneNumber: 'PhoneNumber' as ValidationRuleType,
  Email: 'Email' as ValidationRuleType
};